import React from "react";
import styles from "./Error404.module.scss";

const PageError404 = () => {
  return (
    <div className={styles.center}>
      <div className={styles.error}>
        <div className={styles.number}>4</div>
        <div className={styles.illustration}>
          <div className={styles.circle}></div>
          <div className={styles.clip}>
            <div className={styles.paper}>
              <div className={styles.face}>
                <div className={styles.eyes}>
                  <div className={`${styles.eye} ${styles["eye-left"]}`}></div>
                  <div className={`${styles.eye} ${styles["eye-right"]}`}></div>
                </div>
                <div className={`${styles.rosyCheeks} ${styles["rosyCheeks-left"]}`}></div>
                <div className={`${styles.rosyCheeks} ${styles["rosyCheeks-right"]}`}></div>
                <div className={styles.mouth}></div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.number}>4</div>
      </div>
      <div className={styles.text}>صفحه مورد نظر شما یافت نشد چون در حال توسعه آن هستیم ، به زودی منتشر خواهد شد :) <br /> تشکر از صبر و شکیبایی شما </div>
      <a href="/" className={styles.button}>
        برگشت به خانه
      </a>
    </div>
  );
};

export default PageError404;
